<template>
	<div>
		<div class="position-relative home">
			<!-- shape Hero -->
			<section class="section-shaped">
				<div class="shape shape-style-1 shape-default shape-skew">
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>
				</div>
				<div class="container shape-container d-flex">
					<div class="col px-0">
						<div class="row row-grid justify-content-between">
							<div class="col-lg-8">
								<img class="hero-flyer shadow rounded" :src="hero" />
							</div>
							<div class="col-lg-4">
								<card class="border-0 h-100" shadow body-classes="py-5" v-if="upcomingMeeting.dateUtc">
									<h6 class="text-uppercase">
										<icon name="ni ni-time-alarm" type="primary" rounded class="mb-3"> </icon>
										&nbsp; Следующая встреча
									</h6>
									<div class="description my-2">
										<h3
											style="font-weight: 600"
											class="text-primary"
											:class="{ 'text-danger': !upcomingMeeting.dateUtc }"
											v-html="upcomingMeeting.when"
										></h3>
										<p style="font-weight: 500" class="lead">
											{{ upcomingMeeting.dateUtc.getUTCHours() + 1 }}.{{
												(upcomingMeeting.dateUtc.getUTCMinutes() + '0').slice(0, 2)
											}}
											Братислава <br />

											{{ upcomingMeeting.dateUtc.getUTCHours() - 5 }}.{{
												(upcomingMeeting.dateUtc.getUTCMinutes() + '0').slice(0, 2)
											}}
											Нью-Йорк<br />
										</p>
										<template v-if="upcomingMeeting.speaker">
											<div>Спикер</div>
											<h5 class="text-warning">
												<span class="mt- d-inline-block">{{ upcomingMeeting.speaker }} &nbsp;</span>
												<badge type="primary" rounded class="mb-">{{ upcomingMeeting.topic }}</badge>
											</h5>
										</template>
										<template v-else>
											<b>Тема собрания</b>
											<h5 class="text-warning">
												<span class="d-block">{{ upcomingMeeting.topic }}</span>
											</h5>
										</template>
									</div>
									<base-button
										tag="a"
										target="zoom"
										href="https://us06web.zoom.us/j/2068182542?pwd=N2VSK2R6Q0FKM3FlSWM0ekNtcTZMQT09"
										:type="linkVisible ? 'danger' : 'primary'"
										class="mt-4"
										:class="{ disabled: !linkVisible }"
									>
										Присоединиться в Zoom
									</base-button>
									<p class="text-danger" v-show="!linkVisible"><b>Кнопка активируется за 10 минут до&nbsp;собрания</b></p>
								</card>
							</div>
						</div>
						<div class="row row-grid justify-content-between">
							<div class="col-lg-12">
								<h2 class="text-white my-5">
									<icon name="ni ni-user-run" type="primary" class="mb-3"> </icon>
									Как нас найти?
									<router-link style="text-decoration: underline" class="text-white" :to="{ name: 'contact' }">Посмотреть карту</router-link>
									<icon name="ni ni-pin-3" _type="primary" class="mb-3"> </icon>
								</h2>
								<br />
								<card class="my-3" shadow body-classes="">
									<h2 class="text-warning">
										Алкоголь стал проблемой? Выход есть!
									</h2>
									<p class="lead " style="font-weight: 500; ">
										Позвоните нам <a href="tel:+421949763805">+421949763805</a> или <br />
										отправьте сообщение в <a href="https://wa.me/421949763805" target="_blank">WhatsApp</a>
									</p>
									<p class="text-primary mb-0" style="font-size: 1.2rem"><b>Все контакты с нами полностью анонимны</b></p>
								</card>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import state from '../state';

export default {
	name: 'home',
	components: {},
	data() {
		return {
			linkVisible: state.isMeetingNow(),
			upcomingMeeting: state.upcomingMeeting,
			hero: state.upcomingMeeting.flyer ? `img/flyers/${state.upcomingMeeting.flyer}` : 'img/home-hero.jpg?v=2',
		};
	},

	mounted() {
		setInterval(() => {
			if (!this.linkVisible && state.isMeetingNow()) {
				this.linkVisible = true;
			}
		}, 5 * 1000);
	},
};
</script>

<style lang="scss">
.home {
	.section-shaped > .shape.shape-default {
		background: linear-gradient(150deg, #012060 15%, #8f6ed5 60%, #3755b8 98%);
	}
	.hero-flyer {
		width: 600px;
		max-width: 100%;
	}

	p.text-danger {
		margin-top: 8px;
		margin-bottom: 0;
		line-height: 1.4rem;
	}
}

@media (max-width: 600px) {
	.home {
		.col-lg-8 {
			padding: 0 !important;
			padding-bottom: 30px !important;
		}
		.section-shaped .shape.shape-skew + .shape-container {
			padding-top: 15rem;
		}
	}
}
</style>

